// ─── The sales basis, in one place ──────────────────────────────────────────────
// Every orderStats slice (totals, byChannel, byType, byDay) follows one model
// (API contract "Sales, product margin and delivery", 2026-09-30):
//
//   Sales         = goods + verpakkingskosten + delivery fees
//   Product sales = sales − delivery fees
//   Avg. order    = product sales ÷ orders   (the delivery fee is left out)
//
// Financial users read it ex VAT, after discount. Without order.financial.view
// every ex-VAT field is null, so the same structure is built from the gross
// till amounts instead (incl. VAT, before discount — the discount is served on
// the totals only).

export interface SalesSlice {
  orderCount: number
  grossRevenueCents: number
  packagingFeeCents: number
  deliveryFeeCents: number
  // null without order.financial.view
  turnoverExVatCents: number | null
  productSalesExVatCents: number | null
  deliveryFeeExVatCents: number | null
}

export const salesCents = (s: SalesSlice, canFin: boolean) =>
  canFin ? (s.turnoverExVatCents ?? 0) : s.grossRevenueCents + s.packagingFeeCents + s.deliveryFeeCents

export const productSalesCents = (s: SalesSlice, canFin: boolean) =>
  canFin ? (s.productSalesExVatCents ?? 0) : s.grossRevenueCents + s.packagingFeeCents

export const deliveryFeesCents = (s: SalesSlice, canFin: boolean) =>
  canFin ? (s.deliveryFeeExVatCents ?? 0) : s.deliveryFeeCents

export const avgOrderCents = (s: SalesSlice, canFin: boolean) =>
  s.orderCount > 0 ? Math.round(productSalesCents(s, canFin) / s.orderCount) : 0
